module.exports = __webpack_public_path__ + "img/reach-admin.965156da.png";